<template>
  <modal
    :show="show"
    @hidden="$emit('input', false)"
    title="Download Initiatives"
    submitButtonText="Download"
    modal-class="download-xls-modal"
    @submit="downloadWithOptions"
  >
    <div class="container">
      <div class="row">
        <div class="col-8">
          Compare field values from date<br />
          <small
            >Adds a column for each field in the downloaded sheet that provides the field value on
            the given date.</small
          >
        </div>
        <div class="col">
          <input
            id="compare-with-date-picker"
            type="text"
            class="form-control w-100"
            placeholder="Enter date"
            v-model="downloadOptionCompareWithDate"
            autocomplete="off"
          />
          <b-popover
            ref="compareWithDatePopover"
            placement="bottom"
            triggers="click blur"
            target="compare-with-date-picker"
            boundary="viewport"
          >
            <date-picker :value="downloadOptionCompareWithDate" @input="onDateSelection" />
          </b-popover>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import DatePicker from '@/components/form/DatePicker'
import Modal from '@/components/Modal'
import { BPopover } from 'bootstrap-vue'

export default {
  name: 'DownloadInitiativesModal',
  props: ['show'],
  model: {
    prop: 'show'
  },
  components: {
    Modal,
    BPopover,
    DatePicker
  },
  data() {
    return {
      downloadOptionCompareWithDate: null
    }
  },
  computed: {},
  methods: {
    downloadWithOptions() {
      this.$emit('download', {
        format: 'xlsx',
        compareWithDate: this.downloadOptionCompareWithDate
      })
    },
    onDateSelection(date) {
      this.$refs.compareWithDatePopover.$emit('close')
      this.downloadOptionCompareWithDate = date
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped></style>

<style lang="scss">
.download-xls-modal {
  .modal-content {
    position: static;
  }
  .popover-body {
    padding: 0;
  }
}
</style>
